import { render, staticRenderFns } from "./Tarif.vue?vue&type=template&id=529aadb3&"
import script from "./Tarif.vue?vue&type=script&lang=js&"
export * from "./Tarif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports